module.exports = __webpack_public_path__ + "img/19.de6c1b46.png";